import React from 'react';
import styled from 'styled-components';
import { HorizontalHeader, InfoIcon, Skeleton, User1Icon } from '@exxonmobil/react-unity';
import { useGetClient } from '../utils/withTokenClient';
import { DomainValidation } from '../types/DomainTypes';

const MainHeader = () => {
  const {
    data: domains,
    // error: domainsError,
    isLoading: domainsIsLoading
    // fetch: fetchDomains
  } = useGetClient('domains');

  const wikiUrl = 'https://wiki.fldigital.xom.cloud/#/products/domain_services_dashboard';
  // const datadogStatusUrl = 'https://status.datadoghq.com/';
  return (
    <StyledHeader
      title={
        <a className="em-c-header__title-link" href="/">
          DOMAIN SERVICES DASHBOARD
        </a>
      }
    >
      <HorizontalHeader.Nav>
        <a href="/utilization">
          <HorizontalHeader.Nav.Item>Utilization</HorizontalHeader.Nav.Item>
        </a>
        <a href="/trends">
          <HorizontalHeader.Nav.Item>Trends</HorizontalHeader.Nav.Item>
        </a>
        <DomainDropDown domains={domains ?? []} isLoading={domainsIsLoading} />
        <a href={wikiUrl} target="_blank" rel="noreferrer">
          <HorizontalHeader.Nav.Item>
            About
            <StyledInfoIcon size="small" />
          </HorizontalHeader.Nav.Item>
        </a>
        <HorizontalHeader.Nav.Item>
          <StyledUser1Icon size="small" />
          {/* {`${authRequest().account.name}`} */}
        </HorizontalHeader.Nav.Item>
      </HorizontalHeader.Nav>
    </StyledHeader>
  );
};

const DomainDropDown = ({ domains, isLoading }: { domains: DomainValidation[]; isLoading: boolean }) => (
  <HorizontalHeader.Nav.Dropdown text="Domain">
    {isLoading && <Skeleton />}
    {domains.map((domain) => (
      <a href={`/detail/${domain.id}`}>
        <HorizontalHeader.Nav.Dropdown.Item>{domain.name}</HorizontalHeader.Nav.Dropdown.Item>
      </a>
    ))}
    {/* <HorizontalHeader.Nav.Dropdown.Footer>View all</HorizontalHeader.Nav.Dropdown.Footer> */}
  </HorizontalHeader.Nav.Dropdown>
);

const StyledHeader = styled(HorizontalHeader)`
  background: linear-gradient(90deg, rgba(58, 57, 123, 1) 0%, rgba(189, 47, 127, 1) 100%);
  margin-bottom: 0;
`;

const StyledUser1Icon = styled(User1Icon)`
  margin-right: 0.5rem;
  margin-bottom: 0.1rem;
`;

const StyledInfoIcon = styled(InfoIcon)`
  margin-left: 0.2rem;
  margin-bottom: 0.1rem;
`;

export default MainHeader;
